'use client';
import styled from 'styled-components';

import { breakpoints } from '@styles/breakpoint';
import { Spacers } from '@styles/theme';

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  justify-content: space-between;
  padding-bottom: ${Spacers.XXL}rem;

  ${breakpoints.desktopOrBigger} {
    justify-content: center;
    padding-bottom: 0rem;
    gap: ${Spacers.LG}rem;
  }
`;

export const SuccessTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.MD}rem;

  ${breakpoints.desktopOrBigger} {
    gap: ${Spacers.LG}rem;
  }
`;
